import { render } from "./publication_field.vue?vue&type=template&id=6a27a12e&lang=pug"
import script from "./publication_field.vue?vue&type=script&lang=js"
export * from "./publication_field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__